import { call, put } from "redux-saga/effects";

import * as actions from "../actions";

import { postUserFeedback, postUserFeedbackDismissal } from "../../api/fontApi";

export function* putUserFeedbackSaga({ payload }) {
  try {
    yield call(() => postUserFeedback(payload));
  } catch (error) {
    yield put(actions.addError("userFeedback", error));
  }
}
export function* putUserDismissalSaga({ payload }) {
  try {
    yield call(() => postUserFeedbackDismissal(payload));
  } catch (error) {
    yield put(actions.addError("userFeedbackDismissal", error));
  }
}
